(function ($, Drupal, document) {
  Drupal.behaviors.videoArticle = {
    attach: function (context, settings) {
      // Adjusting the iframe to be responsive
      function adjustIframes() {
        $('iframe').each(function () {
          var
            $this = $(this),
            proportion = $this.data('proportion'),
            w = $this.attr('width'),
            actual_w = $this.width();

          if (!proportion && w > 0) {
            proportion = $this.attr('height') / w;
            $this.data('proportion', proportion);
          }

          if (actual_w != w && actual_w != 0) {
            $this.css('height', Math.round(actual_w * proportion) + 'px');
          }
        });
      }
      if (!$('body').hasClass('node-type--videoartikkel')) {
        $(window).on('resize load', adjustIframes);
      }

      // * Panopto Video
      // Creating object to store all the videos
      var embedApi = {};

      function onPanoptoEmbedApiReady(videoData, videoPosition, durationWrapper, isDemo, isTeaser, counter, playNextVideo) {
        // Selector with data attributes that contains the data for the video
        var video = $(videoData);
        var videoWidth = video[0].dataset.width || 100;
        var videoHeight = video[0].dataset.height || 100;
        var videoSrc = video[0].dataset.src;
        var params = parseQueryString(videoSrc);
        // Define whether the duration wrapper selector is set
        var durationWrapper = durationWrapper ? $(durationWrapper) : false;

        if (videoPosition) {
          // Creating new wrapper for the video to prevent ID duplication
          var player = '<div class="video-wrapper" id="' + videoPosition + '"></div>';
          video.prepend(player);
        }

        // Panopto video initialization. Used an object to have multiple videos asynchronously
        embedApi[counter] = new EmbedApi(videoPosition, {
          width: videoWidth,
          height: videoHeight,
          //This is the URL of your Panopto site
          serverName: "sykepleien.cloud.panopto.eu",
          sessionId: params.id,
          // To get the video duration we have to start the video first
          events: {
            onIframeReady: function () {
              if (isDemo || playNextVideo) {
                // Starting the video on iframe ready
                embedApi[counter].loadVideo();
              }
            },
            onReady: function () {
              if (isDemo) {
                embedApi[counter].muteVideo();
                embedApi[counter].stopVideo();

                // Getting video duration
                var duration = secondsToHMS(embedApi[counter].getDuration());
                var durationNode = window.document.createElement('span');
                durationNode.classList.add('video-duration');
                durationNode.prepend(duration);
                // Prepend video duration data to the DOM
                durationWrapper[0].prepend(durationNode);

                // Removing the video to reset the video preview
                $('#' + videoPosition).remove();
                // Deleting demo video object to clean the object
                delete(embedApi[counter]);

                if (!isTeaser) {
                  // Rerun the function to reset the video view (demo is set to false)
                  if (typeof sessionStorage.isNext != 'undefined' && sessionStorage.isNext != 'false') {
                    sessionStorage.isNext = false;
                    onPanoptoEmbedApiReady('.node-header--article .panopto-video', 'panopto-video', false, false, false, 9998, true);
                  } else {
                    onPanoptoEmbedApiReady('.node-header--article .panopto-video', 'panopto-video', false, false, false, 9998, false);
                  }
                }
              }
            },
            onStateChange: function (state) {
              // Check if the video has ended
              if (state == 0) {
                spinerCountdown('.main-video');
                return false;
              }
            }
          }
        });
      }

      if ($('body').hasClass('node-type--videoartikkel') && $('.panopto-video').length) {
        // Run the function to get the video duration. isDemo set as true -> the video will be deleted after duration is fetched.
        onPanoptoEmbedApiReady('.node-header--article .panopto-video', 'panopto-video-demo', '.article--date-category__label-publisert', true, false, 9999, false);
      } else if ($('.panopto-video').length) {
        // Run the function for the old panopto videos that are not a part of videoartikkel CT
        for (var i = 0; i < $('.panopto-video').length; i++) {
          onPanoptoEmbedApiReady($('.panopto-video').eq(i), 'panopto-video-' + i, false, false, false, 578 + i, false);
        }
      }

      // * Youtube Video
      if ($('.youtube-video').length || $('.teaser-video-data').length) {
        // Creating object to store all the videos
        var YT = {};

        function onYouTubeIframeAPIReady(videoData, videoPosition, durationWrapper, isDemo, isTeaser, counter, playNextVideo) {
          // Selector with data attributes that contains the data for the video
          var video = $(videoData);
          var videoWidth = video[0].dataset.width || 100;
          var videoHeight = video[0].dataset.height || 100;
          var videoSrc = video[0].dataset.src;
          var params = {};
          // Define whether the duration wrapper selector is set
          var durationWrapper = durationWrapper ? $(durationWrapper) : false;

          // Src can differ for youtube videos
          if (videoSrc.includes('https://www.youtube.com/embed/')) {
            params.v = videoSrc.replace('https://www.youtube.com/embed/', '');
          } else {
            params = parseQueryString(videoSrc);
          }

          if (videoPosition) {
            // Creating new wrapper for the video to prevent ID duplication
            var player = '<div class="video-wrapper" id="' + videoPosition + '"></div>';
            video.prepend(player);
          }

          // On youtube API ready
          window.YT.ready(function() {
            // Yotube video initialization. Used an object to have multiple videos asynchronously
            YT[counter] = new window.YT.Player(videoPosition, {
              height: videoHeight,
              width: videoWidth,
              videoId: params.v,
              // To get the video duration we have to start the video first
              events: {
                onReady: function () {
                  if (isDemo) {
                    YT[counter].playVideo();
                    YT[counter].mute();
                    YT[counter].stopVideo();

                    // Getting video duration
                    var duration = secondsToHMS(YT[counter].getDuration());
                    var durationNode = window.document.createElement('span');
                    durationNode.classList.add('video-duration');
                    durationNode.prepend(duration);
                    // Prepend video duration data to the DOM
                    durationWrapper[0].prepend(durationNode);

                    // Removing the video to reset the video view
                    $('#' + videoPosition).remove();

                    // Deleting demo video object to clean the object
                    delete(YT[counter]);

                    if (!isTeaser) {
                      // Rerun the function to reset the video preview
                      if (typeof sessionStorage.isNext != 'undefined' && sessionStorage.isNext != 'false') {
                        sessionStorage.isNext = false;
                        onYouTubeIframeAPIReady('.node-header--article .youtube-video', 'youtube-video', false, false, false, 9998, true);
                      } else {
                        onYouTubeIframeAPIReady('.node-header--article .youtube-video', 'youtube-video', false, false, false, 9998, false);
                      }
                    }
                  } else if (playNextVideo) {
                    YT[counter].playVideo();
                  }
                },
                onStateChange: function (event) {
                  // Check if the video has ended
                  if (event.data == 0) {
                    spinerCountdown('.main-video');
                  }
                }
              }
            });
          });
        }

        if ($('body').hasClass('node-type--videoartikkel') && $('.youtube-video').length) {
          // Run the function to get the video duration. isDemo set as true -> the video will be deleted after duration is fetched.
          onYouTubeIframeAPIReady('.node-header--article .youtube-video', 'youtube-video-demo', '.article--date-category__label-publisert', true, false, 9999, false);
        } else if ($('.youtube-video').length) {
          // Run the function for the old youtube videos that are not a part of videoartikkel CT
          for (var i = 0; i < $('.youtube-video').length; i++) {
            onYouTubeIframeAPIReady($('.youtube-video').eq(i), 'youtube-video-' + i, false, false, false, 7812 + i, false);
          }
        }
      }

      // Setting video duration for the video teasers
      if ($('.teaser-video-data').length) {
        var $videoTeasers = $('.teaser-video-data');
        // Creating object to store all the videos
        var playlist = {};

        for (var i = 0; i < $videoTeasers.length; i++) {
          var $this = $videoTeasers[i];
          // Generating unique ID
          var $position = 'teaser-demo-' + i;
          $($this).append('<div class="time"></div>');
          var $durationWrapper = $($this).find('.time');

          // Storing video teasers into an object
          playlist[i] = {};
          playlist[i]['current'] = false;
          playlist[i]['object'] = $($this);

          // Define current page video
          if ($($this).closest('.teaser-wrapper').hasClass('current-video')) {
            playlist[i]['current'] = true;
          }

          if ($($this).hasClass('panopto-teaser')) {
            onPanoptoEmbedApiReady($this, $position, $durationWrapper, true, true, i, false);
          } else if ($($this).hasClass('youtube-teaser')) {
            onYouTubeIframeAPIReady($this, $position, $durationWrapper, true, true, i, false);
          }
        }
      }

      // Define which video should play after current one ends
      function nextVideo(playlist) {
        for (var i = 0; i < Object.keys(playlist).length; i++) {
          var $this = playlist[i];

          if ($this['current'] == true) {
            if (typeof(playlist[i + 1]) != 'undefined') {
              $this['current'] = false;
              playlist[i + 1]['current'] = true;
              return playlist[i + 1];
            } else {
              $this['current'] = false;
              playlist[0]['current'] = true;
              return playlist[0];
            }
          }
        }
      }

      function playNextVideo(playlist, timer) {
        // Fetching an object from next video
        var $nextVideo = nextVideo(playlist)['object'];
        var $pathname = $nextVideo.find('h2 a').attr('href');

        // Clearing an interval
        clearInterval(timer);
        $('.countdown').remove();
        // Go to new next video page
        sessionStorage.isNext = true;
        location.pathname = $pathname;
      }

      // Creating a spinner countdown when the video ends
      function spinerCountdown(element) {
        if ($('body').hasClass('node-type--videoartikkel') && $('.teaser-video-data').length > 1) {
          var counter = 5;
          // Remove the node object if it is already exists
          $('.countdown').remove();

          // Creating new countdown node object
          $(element).append(
            '<div class="countdown"><div class="circle-timer"><div class="timer-slot"><div class="timer-lt"></div></div>' +
            '<div class="timer-slot"><div class="timer-rt"></div></div><div class="counter">' + counter +
            '</div><div class="counter-cancel">' + Drupal.t('avbryt') + '</div></div></div>');

          // Setting interval counter
          var countdownTimer = setInterval(function () {
            if (counter > 0) {
              counter--;
              $(element).find('.counter').text(counter);
            }
            else {
              playNextVideo(playlist, countdownTimer);
            }
          }, 1000);

          $('.counter-cancel').click(function () {
            $('.countdown').remove();
            counter = 5;
            clearInterval(countdownTimer);
          });
        }
      }

      // Converting seconds to H:M:S format
      function secondsToHMS(d) {
        d = Number(d);
        var h = Math.floor(d / 3600);
        var m = Math.floor(d % 3600 / 60);
        var s = Math.floor(d % 3600 % 60);

        var hDisplay = h > 0 ? (h < 10 ? '0' + h + ':' : h + ':') : '';
        var mDisplay = m > 0 ? (m < 10 ? '0' + m + ':' : m + ':') : '00:';
        var sDisplay = s > 0 ? (s < 10 ? '0' + s : s) : '00';
        return hDisplay + mDisplay + sDisplay;
      }

      // Split video src to object with data
      function parseQueryString(src) {
        var str = src;
        var objURL = {};

        str.replace(
          new RegExp("([^?=&]+)(=([^&]*))?", "g"),
          function($0, $1, $2, $3) {
            objURL[ $1 ] = $3;
          }
        );
        return objURL;
      };
    }
  };
}(jQuery, Drupal));
